import React from "react";

type Props = {
    className?: string;
};

export default function ChevronDown(props: Props) {
    return (
        <svg
            className={props.className}
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="8"
            viewBox="0 0 11 8"
        >
            <g fill="none" fillRule="evenodd">
                <g fill="#22215F" fillRule="nonzero">
                    <g>
                        <path
                            d="M324.737 26.825L328.6 23 324.737 19.175 325.926 18 330.987 23 325.926 28z"
                            transform="translate(-450 -446) translate(128 427) matrix(0 1 1 0 304.862 -304.862)"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
}
